import { useEffect, useState, useRef } from 'react'
import Typed from 'typed.js'
import { createClient } from '@sanity/client'
import { fetchHeroData } from '../api'
import { toast } from 'react-toastify'
import COPY from './copy'

export default function TypedJS() {
  const el = useRef(null)
  const [heroData, setHeroData] = useState<{ _id: string; heading: string }[]>([])

  useEffect(() => {
    const client = createClient({
      projectId: COPY.SANITY_PROJECT_ID,
      dataset: COPY.SANITY_DATASET,
      apiVersion: COPY.SANITY_API_VERSION,
      useCdn: true,
    })

    client
      .fetch(fetchHeroData)
      .then((data) => {
        setHeroData(data)
      })
      .catch((error) =>
        toast.error(error, {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        }),
      )
  }, [])

  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: heroData.map((data) => data.heading),
      startDelay: 500,
      typeSpeed: 100,
      backSpeed: 50,
      backDelay: 500,
      smartBackspace: true,
      loop: true,
      showCursor: true,
    })

    return () => {
      typed.destroy()
    }
  }, [heroData])

  return (
    <div className='mb-6'>
      <p className='text-white max-sm:text-3xl max-lg:text-4xl max-lg:px-4 max-sm:h-32 text-center text-5xl font-black'>
        {COPY.WE_HELP_WITH}
        <span className='ml-2' ref={el} />
      </p>
    </div>
  )
}
